export default __webpack_public_path__ + "static/media/your-adventure.e85663bb.png";